window.SharedConfig = 
{
    currencySymbol: "&pound;",
    maximumBasketValue: 500,
    maximumBasketUnits: 10
}

window.SharedUtils = {
    currencyFormat: function (num) {
        return SharedConfig.currencySymbol + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    objectLength: function (object) {
        var length = 0;
        for (var key in object) {
            length++;
        }
        return length;
    },
    maxBasketValueStr: function () {
        var tmp = SharedConfig.maximumBasketValue;
        return SharedConfig.currencySymbol + tmp.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    isNumeric: function(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

}